export const theme = {
  fonts: {
    body: "Montserrat, sans-serif",
    logo: "Poppins, sans-serif",
    sex: "Love Light",
  },

  //           0   1   2   3   4   5   6   7   8   9  10  11
  fontSizes: [12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 64, 72],

  fontWeights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  colors: {
    background:
      "linear-gradient(114.99deg, #471CA9 -0.99%, #5736A3 54.28%, #4B2A99 78.99%)",
    accent: "#EBD8FF",
    black: "#373737",
    green: "#5CD3A8",
  },

  //border-radius
  radii: {
    tiny: "10px",
    small: "20px",
    normal: "40px",
    round: "50%",
  },

  device: {
    mobile: "(min-width: 320px)",
    tablet: "(min-width: 768px)",
    desktop: "(min-width: 1280px)",
  },

  transition: "0.2s all linear",
};
